import { MenuGroup } from './types'

// Filter out menu groups with 0 items, recursively
export const filterMenuGroupsByItemCount = (
  groups: MenuGroup[]
): MenuGroup[] => {
  return groups
    .filter((group) => group.itemCount > 0)
    .map((group) => ({
      ...group,
      children: group.children
        ? filterMenuGroupsByItemCount(group.children)
        : group.children
    }))
}
